import PropTypes from "prop-types"
import { useEffect } from "react"

import useAffirm from "helpers/checkout/use-affirm"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

const Affirm = ({ inCart, price }) => {
  const affirmLoaded = useAffirm()
  const { isTablet } = useWindowDimensions()

  useEffect(() => {
    if (!affirmLoaded) return

    if (
      typeof window.affirm !== "undefined" &&
      window.affirm.ui &&
      window.affirm.ui.refresh
    ) {
      window.affirm.ui.refresh()
    }
  }, [affirmLoaded, isTablet, price])

  if (!price) return null

  return (
    <div
      className={cn(
        "text-grey-500 text-11 block cursor-pointer text-left font-semibold [&_a]:underline [&_a]:hover:no-underline [&_a]:focus:no-underline",
        !inCart && "tablet:text-right"
      )}
      style={{ minHeight: "18px" }}
    >
      <span
        className="affirm-as-low-as"
        // data-affirm-color={logoColor}
        data-amount={price}
        data-learnmore-show="false"
        data-page-type="product"
      />
    </div>
  )
}

Affirm.propTypes = {
  inCart: PropTypes.bool,
  price: PropTypes.number,
}

export default Affirm
